import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<UnauthorizedComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {}

  public closeClick = () => {
    this.dialogRef.close({ response: null });
  };
}
